// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* BORDERS */\n\n/* Icons */\n\n/* BORDERS */\n\n/* Icons */\n@media (width <= 600px) {\n.version-cell {\n    border-right: none !important;\n}\n}\n.v-dialog {\n  overflow-y: hidden !important;\n  display: flex;\n  flex-direction: column;\n}\n.dialog-content {\n  overflow-y: scroll;\n}", ""]);
// Exports
module.exports = exports;
